import React from 'react';
import {
  Card as TWCard,
  CardHeader as TWCardHeader,
  CardTitle as TWCardTitle,
  CardContent as TWCardContent,
  CardFooter as TWCardFooter,
  CardDescription as TWCardDescription,
} from '../tailwind/ui/card';
import { cn } from '../tailwind/lib/utils';
import { Tooltip } from '../tooltip';
// ... existing code ...
// Tip: Adapte as interfaces ICardProps e ICardHeaderProps conforme necessário para o novo padrão.

export const Card: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  ...props
}) => (
  <TWCard
    {...props}
    className={cn(
      'p-5 rounded-lg border border-[#E3E3E3] bg-white relative break-inside-avoid-page',
      props.className
    )}
  >
    {children}
  </TWCard>
);

export const CardHeader: React.FC<
  React.HTMLAttributes<HTMLDivElement> & {
    title?: string | React.ReactNode | Element
    subTitle?: React.ReactNode;
    cardFooter?: React.ReactNode;
    headerActions?: React.ReactNode;
    tooltipText?: string | React.ReactNode;
  }
> = ({
  title,
  subTitle,
  cardFooter,
  headerActions,
  tooltipText,
  children,
  ...props
}) => (
  <Card {...props}>
    <TWCardHeader>
      <div className="flex flex-col gap-1">
        {title && (
          <div className="flex items-center">
            <TWCardTitle className={subTitle ? 'pb-0' : ''}>
              {title}
            </TWCardTitle>
            {tooltipText && <Tooltip text={tooltipText} />}
          </div>
        )}
        {subTitle && <TWCardDescription>{subTitle}</TWCardDescription>}
      </div>

      {headerActions && headerActions}
    </TWCardHeader>
    <TWCardContent className="p-0">{children}</TWCardContent>
    {cardFooter && <TWCardFooter>{cardFooter}</TWCardFooter>}
  </Card>
);
